import { default as indexQWKFaMHH2OMeta } from "/app/pages/account/index.vue?macro=true";
import { default as indexKaDQ4zOcwVMeta } from "/app/pages/affiliate-program/index.vue?macro=true";
import { default as indexzknaIoIHO3Meta } from "/app/pages/b2b/index.vue?macro=true";
import { default as _91orderId_93dNhGxD6S2EMeta } from "/app/pages/dashboard/generate/[orderId].vue?macro=true";
import { default as _91segmentId_93QRPCmLxoFlMeta } from "/app/pages/dashboard/generate/manual-masking/[orderId]/[objectName]/[segmentId].vue?macro=true";
import { default as _91orderId_93twjN1B9XfLMeta } from "/app/pages/dashboard/result/[orderId].vue?macro=true";
import { default as indexDzEIP06qKVMeta } from "/app/pages/dashboard/services/index.vue?macro=true";
import { default as _91serviceName_93WrhplvqjFdMeta } from "/app/pages/dashboard/upload-photo/[serviceName].vue?macro=true";
import { default as indexdvAgjYARWWMeta } from "/app/pages/day-to-dusk/index.vue?macro=true";
import { default as index1xu8Iyt0NWMeta } from "/app/pages/home-renovation/index.vue?macro=true";
import { default as _91id_93KdpQr6NHRoMeta } from "/app/pages/ideas/[landing]/[id].vue?macro=true";
import { default as indexFL10LOx8fdMeta } from "/app/pages/ideas/[landing]/index.vue?macro=true";
import { default as indexQ0fd8Nluc5Meta } from "/app/pages/ideas/index.vue?macro=true";
import { default as _91url_93IWurBbTXWtMeta } from "/app/pages/ideas/top-ideas-picks/[url].vue?macro=true";
import { default as index0jvEPa7OuHMeta } from "/app/pages/image-enhancement/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as indexE0sO6VUll1Meta } from "/app/pages/interior-design/index.vue?macro=true";
import { default as indexYIoJIKFD7YMeta } from "/app/pages/item-removal/index.vue?macro=true";
import { default as indexAyqsaymgxVMeta } from "/app/pages/miamirealtors/index.vue?macro=true";
import { default as indexZ6EUJ1816QMeta } from "/app/pages/nar-nxt2024/index.vue?macro=true";
import { default as indexZu37Q4vm8IMeta } from "/app/pages/payment/index.vue?macro=true";
import { default as indexSaNcJ0PtofMeta } from "/app/pages/photo-editing/index.vue?macro=true";
import { default as indext2mji5fLq5Meta } from "/app/pages/privacy-policy/index.vue?macro=true";
import { default as indexAP3vXSxH1jMeta } from "/app/pages/refund-policy/index.vue?macro=true";
import { default as _91id_931wqDLF4m1jMeta } from "/app/pages/share/[id].vue?macro=true";
import { default as indexeGU814pWZWMeta } from "/app/pages/terms-and-conditions/index.vue?macro=true";
import { default as indexzzHG5wCQGdMeta } from "/app/pages/virtual-staging/index.vue?macro=true";
import { default as indexppcWwnaIjyMeta } from "/app/modules/pricing/pages/index.vue?macro=true";
import { default as indexs61vCSxqLMMeta } from "/app/modules/billing/pages/index.vue?macro=true";
import { default as indexTzFcCB2TOWMeta } from "/app/modules/api-access/pages/index.vue?macro=true";
import { default as logs2gDoHoeyr8Meta } from "/app/modules/api-access/pages/logs.vue?macro=true";
import { default as singleLIXEwMzMWKMeta } from "/app/modules/bulk/pages/single.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/app/node_modules/nuxt/dist/components/runtime/client-component").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as multiCOGediCAuRMeta } from "/app/modules/bulk/pages/multi.vue?macro=true";
import { default as index7R0Nkm3DOvMeta } from "/app/modules/bulk/pages/index.vue?macro=true";
import { default as indexq0RnSEaoHEMeta } from "/app/modules/generated-photos/pages/index.vue?macro=true";
import { default as singleq818QydQhsMeta } from "/app/modules/generated-photos/pages/single.vue?macro=true";
import { default as singleGroupMKq5TLXY9KMeta } from "/app/modules/generated-photos/pages/singleGroup.vue?macro=true";
import { default as singleL8F2sP93JjMeta } from "/app/modules/generated-photos/pages/bookmark/single.vue?macro=true";
import { default as IRDrawFjW0lcuOW0Meta } from "/app/modules/ir-mask/pages/IRDraw.vue?macro=true";
import { default as DayToDuskaw1bmjnIdLMeta } from "/app/modules/day-to-dusk/pages/DayToDusk.vue?macro=true";
import { default as membersW5qEhMW9jbMeta } from "/app/modules/sub-account/pages/members.vue?macro=true";
import { default as verifyU9K92YbSeyMeta } from "/app/modules/sub-account/pages/verify.vue?macro=true";
import { default as component_45stubTOq3NWgWLHMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubTOq3NWgWLH } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: indexQWKFaMHH2OMeta?.name ?? "account___en",
    path: indexQWKFaMHH2OMeta?.path ?? "/account",
    meta: indexQWKFaMHH2OMeta || {},
    alias: indexQWKFaMHH2OMeta?.alias || [],
    redirect: indexQWKFaMHH2OMeta?.redirect,
    component: () => import("/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexQWKFaMHH2OMeta?.name ?? "account___en-gb",
    path: indexQWKFaMHH2OMeta?.path ?? "/en-gb/account",
    meta: indexQWKFaMHH2OMeta || {},
    alias: indexQWKFaMHH2OMeta?.alias || [],
    redirect: indexQWKFaMHH2OMeta?.redirect,
    component: () => import("/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexQWKFaMHH2OMeta?.name ?? "account___fr",
    path: indexQWKFaMHH2OMeta?.path ?? "/fr/account",
    meta: indexQWKFaMHH2OMeta || {},
    alias: indexQWKFaMHH2OMeta?.alias || [],
    redirect: indexQWKFaMHH2OMeta?.redirect,
    component: () => import("/app/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: indexKaDQ4zOcwVMeta?.name ?? "affiliate-program___en",
    path: indexKaDQ4zOcwVMeta?.path ?? "/affiliate-program",
    meta: indexKaDQ4zOcwVMeta || {},
    alias: indexKaDQ4zOcwVMeta?.alias || [],
    redirect: indexKaDQ4zOcwVMeta?.redirect,
    component: () => import("/app/pages/affiliate-program/index.vue").then(m => m.default || m)
  },
  {
    name: indexKaDQ4zOcwVMeta?.name ?? "affiliate-program___en-gb",
    path: indexKaDQ4zOcwVMeta?.path ?? "/en-gb/affiliate-program",
    meta: indexKaDQ4zOcwVMeta || {},
    alias: indexKaDQ4zOcwVMeta?.alias || [],
    redirect: indexKaDQ4zOcwVMeta?.redirect,
    component: () => import("/app/pages/affiliate-program/index.vue").then(m => m.default || m)
  },
  {
    name: indexKaDQ4zOcwVMeta?.name ?? "affiliate-program___fr",
    path: indexKaDQ4zOcwVMeta?.path ?? "/fr/affiliate-program",
    meta: indexKaDQ4zOcwVMeta || {},
    alias: indexKaDQ4zOcwVMeta?.alias || [],
    redirect: indexKaDQ4zOcwVMeta?.redirect,
    component: () => import("/app/pages/affiliate-program/index.vue").then(m => m.default || m)
  },
  {
    name: indexzknaIoIHO3Meta?.name ?? "b2b___en",
    path: indexzknaIoIHO3Meta?.path ?? "/b2b",
    meta: indexzknaIoIHO3Meta || {},
    alias: indexzknaIoIHO3Meta?.alias || [],
    redirect: indexzknaIoIHO3Meta?.redirect,
    component: () => import("/app/pages/b2b/index.vue").then(m => m.default || m)
  },
  {
    name: indexzknaIoIHO3Meta?.name ?? "b2b___en-gb",
    path: indexzknaIoIHO3Meta?.path ?? "/en-gb/b2b",
    meta: indexzknaIoIHO3Meta || {},
    alias: indexzknaIoIHO3Meta?.alias || [],
    redirect: indexzknaIoIHO3Meta?.redirect,
    component: () => import("/app/pages/b2b/index.vue").then(m => m.default || m)
  },
  {
    name: indexzknaIoIHO3Meta?.name ?? "b2b___fr",
    path: indexzknaIoIHO3Meta?.path ?? "/fr/b2b",
    meta: indexzknaIoIHO3Meta || {},
    alias: indexzknaIoIHO3Meta?.alias || [],
    redirect: indexzknaIoIHO3Meta?.redirect,
    component: () => import("/app/pages/b2b/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderId_93dNhGxD6S2EMeta?.name ?? "dashboard-generate-orderId___en",
    path: _91orderId_93dNhGxD6S2EMeta?.path ?? "/dashboard/generate/:orderId()",
    meta: _91orderId_93dNhGxD6S2EMeta || {},
    alias: _91orderId_93dNhGxD6S2EMeta?.alias || [],
    redirect: _91orderId_93dNhGxD6S2EMeta?.redirect,
    component: () => import("/app/pages/dashboard/generate/[orderId].vue").then(m => m.default || m)
  },
  {
    name: _91orderId_93dNhGxD6S2EMeta?.name ?? "dashboard-generate-orderId___en-gb",
    path: _91orderId_93dNhGxD6S2EMeta?.path ?? "/en-gb/dashboard/generate/:orderId()",
    meta: _91orderId_93dNhGxD6S2EMeta || {},
    alias: _91orderId_93dNhGxD6S2EMeta?.alias || [],
    redirect: _91orderId_93dNhGxD6S2EMeta?.redirect,
    component: () => import("/app/pages/dashboard/generate/[orderId].vue").then(m => m.default || m)
  },
  {
    name: _91orderId_93dNhGxD6S2EMeta?.name ?? "dashboard-generate-orderId___fr",
    path: _91orderId_93dNhGxD6S2EMeta?.path ?? "/fr/dashboard/generate/:orderId()",
    meta: _91orderId_93dNhGxD6S2EMeta || {},
    alias: _91orderId_93dNhGxD6S2EMeta?.alias || [],
    redirect: _91orderId_93dNhGxD6S2EMeta?.redirect,
    component: () => import("/app/pages/dashboard/generate/[orderId].vue").then(m => m.default || m)
  },
  {
    name: _91segmentId_93QRPCmLxoFlMeta?.name ?? "dashboard-generate-manual-masking-orderId-objectName-segmentId___en",
    path: _91segmentId_93QRPCmLxoFlMeta?.path ?? "/dashboard/generate/manual-masking/:orderId()/:objectName()/:segmentId()",
    meta: _91segmentId_93QRPCmLxoFlMeta || {},
    alias: _91segmentId_93QRPCmLxoFlMeta?.alias || [],
    redirect: _91segmentId_93QRPCmLxoFlMeta?.redirect,
    component: () => import("/app/pages/dashboard/generate/manual-masking/[orderId]/[objectName]/[segmentId].vue").then(m => m.default || m)
  },
  {
    name: _91segmentId_93QRPCmLxoFlMeta?.name ?? "dashboard-generate-manual-masking-orderId-objectName-segmentId___en-gb",
    path: _91segmentId_93QRPCmLxoFlMeta?.path ?? "/en-gb/dashboard/generate/manual-masking/:orderId()/:objectName()/:segmentId()",
    meta: _91segmentId_93QRPCmLxoFlMeta || {},
    alias: _91segmentId_93QRPCmLxoFlMeta?.alias || [],
    redirect: _91segmentId_93QRPCmLxoFlMeta?.redirect,
    component: () => import("/app/pages/dashboard/generate/manual-masking/[orderId]/[objectName]/[segmentId].vue").then(m => m.default || m)
  },
  {
    name: _91segmentId_93QRPCmLxoFlMeta?.name ?? "dashboard-generate-manual-masking-orderId-objectName-segmentId___fr",
    path: _91segmentId_93QRPCmLxoFlMeta?.path ?? "/fr/dashboard/generate/manual-masking/:orderId()/:objectName()/:segmentId()",
    meta: _91segmentId_93QRPCmLxoFlMeta || {},
    alias: _91segmentId_93QRPCmLxoFlMeta?.alias || [],
    redirect: _91segmentId_93QRPCmLxoFlMeta?.redirect,
    component: () => import("/app/pages/dashboard/generate/manual-masking/[orderId]/[objectName]/[segmentId].vue").then(m => m.default || m)
  },
  {
    name: _91orderId_93twjN1B9XfLMeta?.name ?? "dashboard-result-orderId___en",
    path: _91orderId_93twjN1B9XfLMeta?.path ?? "/dashboard/result/:orderId()",
    meta: _91orderId_93twjN1B9XfLMeta || {},
    alias: _91orderId_93twjN1B9XfLMeta?.alias || [],
    redirect: _91orderId_93twjN1B9XfLMeta?.redirect,
    component: () => import("/app/pages/dashboard/result/[orderId].vue").then(m => m.default || m)
  },
  {
    name: _91orderId_93twjN1B9XfLMeta?.name ?? "dashboard-result-orderId___en-gb",
    path: _91orderId_93twjN1B9XfLMeta?.path ?? "/en-gb/dashboard/result/:orderId()",
    meta: _91orderId_93twjN1B9XfLMeta || {},
    alias: _91orderId_93twjN1B9XfLMeta?.alias || [],
    redirect: _91orderId_93twjN1B9XfLMeta?.redirect,
    component: () => import("/app/pages/dashboard/result/[orderId].vue").then(m => m.default || m)
  },
  {
    name: _91orderId_93twjN1B9XfLMeta?.name ?? "dashboard-result-orderId___fr",
    path: _91orderId_93twjN1B9XfLMeta?.path ?? "/fr/dashboard/result/:orderId()",
    meta: _91orderId_93twjN1B9XfLMeta || {},
    alias: _91orderId_93twjN1B9XfLMeta?.alias || [],
    redirect: _91orderId_93twjN1B9XfLMeta?.redirect,
    component: () => import("/app/pages/dashboard/result/[orderId].vue").then(m => m.default || m)
  },
  {
    name: indexDzEIP06qKVMeta?.name ?? "dashboard-services___en",
    path: indexDzEIP06qKVMeta?.path ?? "/dashboard/services",
    meta: indexDzEIP06qKVMeta || {},
    alias: indexDzEIP06qKVMeta?.alias || [],
    redirect: indexDzEIP06qKVMeta?.redirect,
    component: () => import("/app/pages/dashboard/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexDzEIP06qKVMeta?.name ?? "dashboard-services___en-gb",
    path: indexDzEIP06qKVMeta?.path ?? "/en-gb/dashboard/services",
    meta: indexDzEIP06qKVMeta || {},
    alias: indexDzEIP06qKVMeta?.alias || [],
    redirect: indexDzEIP06qKVMeta?.redirect,
    component: () => import("/app/pages/dashboard/services/index.vue").then(m => m.default || m)
  },
  {
    name: indexDzEIP06qKVMeta?.name ?? "dashboard-services___fr",
    path: indexDzEIP06qKVMeta?.path ?? "/fr/dashboard/services",
    meta: indexDzEIP06qKVMeta || {},
    alias: indexDzEIP06qKVMeta?.alias || [],
    redirect: indexDzEIP06qKVMeta?.redirect,
    component: () => import("/app/pages/dashboard/services/index.vue").then(m => m.default || m)
  },
  {
    name: _91serviceName_93WrhplvqjFdMeta?.name ?? "dashboard-upload-photo-serviceName___en",
    path: _91serviceName_93WrhplvqjFdMeta?.path ?? "/dashboard/upload-photo/:serviceName()",
    meta: _91serviceName_93WrhplvqjFdMeta || {},
    alias: _91serviceName_93WrhplvqjFdMeta?.alias || [],
    redirect: _91serviceName_93WrhplvqjFdMeta?.redirect,
    component: () => import("/app/pages/dashboard/upload-photo/[serviceName].vue").then(m => m.default || m)
  },
  {
    name: _91serviceName_93WrhplvqjFdMeta?.name ?? "dashboard-upload-photo-serviceName___en-gb",
    path: _91serviceName_93WrhplvqjFdMeta?.path ?? "/en-gb/dashboard/upload-photo/:serviceName()",
    meta: _91serviceName_93WrhplvqjFdMeta || {},
    alias: _91serviceName_93WrhplvqjFdMeta?.alias || [],
    redirect: _91serviceName_93WrhplvqjFdMeta?.redirect,
    component: () => import("/app/pages/dashboard/upload-photo/[serviceName].vue").then(m => m.default || m)
  },
  {
    name: _91serviceName_93WrhplvqjFdMeta?.name ?? "dashboard-upload-photo-serviceName___fr",
    path: _91serviceName_93WrhplvqjFdMeta?.path ?? "/fr/dashboard/upload-photo/:serviceName()",
    meta: _91serviceName_93WrhplvqjFdMeta || {},
    alias: _91serviceName_93WrhplvqjFdMeta?.alias || [],
    redirect: _91serviceName_93WrhplvqjFdMeta?.redirect,
    component: () => import("/app/pages/dashboard/upload-photo/[serviceName].vue").then(m => m.default || m)
  },
  {
    name: indexdvAgjYARWWMeta?.name ?? "day-to-dusk___en",
    path: indexdvAgjYARWWMeta?.path ?? "/day-to-dusk",
    meta: indexdvAgjYARWWMeta || {},
    alias: indexdvAgjYARWWMeta?.alias || [],
    redirect: indexdvAgjYARWWMeta?.redirect,
    component: () => import("/app/pages/day-to-dusk/index.vue").then(m => m.default || m)
  },
  {
    name: indexdvAgjYARWWMeta?.name ?? "day-to-dusk___en-gb",
    path: indexdvAgjYARWWMeta?.path ?? "/en-gb/day-to-dusk",
    meta: indexdvAgjYARWWMeta || {},
    alias: indexdvAgjYARWWMeta?.alias || [],
    redirect: indexdvAgjYARWWMeta?.redirect,
    component: () => import("/app/pages/day-to-dusk/index.vue").then(m => m.default || m)
  },
  {
    name: indexdvAgjYARWWMeta?.name ?? "day-to-dusk___fr",
    path: indexdvAgjYARWWMeta?.path ?? "/fr/day-to-dusk",
    meta: indexdvAgjYARWWMeta || {},
    alias: indexdvAgjYARWWMeta?.alias || [],
    redirect: indexdvAgjYARWWMeta?.redirect,
    component: () => import("/app/pages/day-to-dusk/index.vue").then(m => m.default || m)
  },
  {
    name: index1xu8Iyt0NWMeta?.name ?? "home-renovation___en",
    path: index1xu8Iyt0NWMeta?.path ?? "/home-renovation",
    meta: index1xu8Iyt0NWMeta || {},
    alias: index1xu8Iyt0NWMeta?.alias || [],
    redirect: index1xu8Iyt0NWMeta?.redirect,
    component: () => import("/app/pages/home-renovation/index.vue").then(m => m.default || m)
  },
  {
    name: index1xu8Iyt0NWMeta?.name ?? "home-renovation___en-gb",
    path: index1xu8Iyt0NWMeta?.path ?? "/en-gb/home-renovation",
    meta: index1xu8Iyt0NWMeta || {},
    alias: index1xu8Iyt0NWMeta?.alias || [],
    redirect: index1xu8Iyt0NWMeta?.redirect,
    component: () => import("/app/pages/home-renovation/index.vue").then(m => m.default || m)
  },
  {
    name: index1xu8Iyt0NWMeta?.name ?? "home-renovation___fr",
    path: index1xu8Iyt0NWMeta?.path ?? "/fr/home-renovation",
    meta: index1xu8Iyt0NWMeta || {},
    alias: index1xu8Iyt0NWMeta?.alias || [],
    redirect: index1xu8Iyt0NWMeta?.redirect,
    component: () => import("/app/pages/home-renovation/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93KdpQr6NHRoMeta?.name ?? "ideas-landing-id___en",
    path: _91id_93KdpQr6NHRoMeta?.path ?? "/ideas/:landing()/:id()",
    meta: _91id_93KdpQr6NHRoMeta || {},
    alias: _91id_93KdpQr6NHRoMeta?.alias || [],
    redirect: _91id_93KdpQr6NHRoMeta?.redirect,
    component: () => import("/app/pages/ideas/[landing]/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93KdpQr6NHRoMeta?.name ?? "ideas-landing-id___en-gb",
    path: _91id_93KdpQr6NHRoMeta?.path ?? "/en-gb/ideas/:landing()/:id()",
    meta: _91id_93KdpQr6NHRoMeta || {},
    alias: _91id_93KdpQr6NHRoMeta?.alias || [],
    redirect: _91id_93KdpQr6NHRoMeta?.redirect,
    component: () => import("/app/pages/ideas/[landing]/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93KdpQr6NHRoMeta?.name ?? "ideas-landing-id___fr",
    path: _91id_93KdpQr6NHRoMeta?.path ?? "/fr/ideas/:landing()/:id()",
    meta: _91id_93KdpQr6NHRoMeta || {},
    alias: _91id_93KdpQr6NHRoMeta?.alias || [],
    redirect: _91id_93KdpQr6NHRoMeta?.redirect,
    component: () => import("/app/pages/ideas/[landing]/[id].vue").then(m => m.default || m)
  },
  {
    name: indexFL10LOx8fdMeta?.name ?? "ideas-landing___en",
    path: indexFL10LOx8fdMeta?.path ?? "/ideas/:landing()",
    meta: indexFL10LOx8fdMeta || {},
    alias: indexFL10LOx8fdMeta?.alias || [],
    redirect: indexFL10LOx8fdMeta?.redirect,
    component: () => import("/app/pages/ideas/[landing]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFL10LOx8fdMeta?.name ?? "ideas-landing___en-gb",
    path: indexFL10LOx8fdMeta?.path ?? "/en-gb/ideas/:landing()",
    meta: indexFL10LOx8fdMeta || {},
    alias: indexFL10LOx8fdMeta?.alias || [],
    redirect: indexFL10LOx8fdMeta?.redirect,
    component: () => import("/app/pages/ideas/[landing]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFL10LOx8fdMeta?.name ?? "ideas-landing___fr",
    path: indexFL10LOx8fdMeta?.path ?? "/fr/ideas/:landing()",
    meta: indexFL10LOx8fdMeta || {},
    alias: indexFL10LOx8fdMeta?.alias || [],
    redirect: indexFL10LOx8fdMeta?.redirect,
    component: () => import("/app/pages/ideas/[landing]/index.vue").then(m => m.default || m)
  },
  {
    name: indexQ0fd8Nluc5Meta?.name ?? "ideas___en",
    path: indexQ0fd8Nluc5Meta?.path ?? "/ideas",
    meta: indexQ0fd8Nluc5Meta || {},
    alias: indexQ0fd8Nluc5Meta?.alias || [],
    redirect: indexQ0fd8Nluc5Meta?.redirect,
    component: () => import("/app/pages/ideas/index.vue").then(m => m.default || m)
  },
  {
    name: indexQ0fd8Nluc5Meta?.name ?? "ideas___en-gb",
    path: indexQ0fd8Nluc5Meta?.path ?? "/en-gb/ideas",
    meta: indexQ0fd8Nluc5Meta || {},
    alias: indexQ0fd8Nluc5Meta?.alias || [],
    redirect: indexQ0fd8Nluc5Meta?.redirect,
    component: () => import("/app/pages/ideas/index.vue").then(m => m.default || m)
  },
  {
    name: indexQ0fd8Nluc5Meta?.name ?? "ideas___fr",
    path: indexQ0fd8Nluc5Meta?.path ?? "/fr/ideas",
    meta: indexQ0fd8Nluc5Meta || {},
    alias: indexQ0fd8Nluc5Meta?.alias || [],
    redirect: indexQ0fd8Nluc5Meta?.redirect,
    component: () => import("/app/pages/ideas/index.vue").then(m => m.default || m)
  },
  {
    name: _91url_93IWurBbTXWtMeta?.name ?? "ideas-top-ideas-picks-url___en",
    path: _91url_93IWurBbTXWtMeta?.path ?? "/ideas/top-ideas-picks/:url()",
    meta: _91url_93IWurBbTXWtMeta || {},
    alias: _91url_93IWurBbTXWtMeta?.alias || [],
    redirect: _91url_93IWurBbTXWtMeta?.redirect,
    component: () => import("/app/pages/ideas/top-ideas-picks/[url].vue").then(m => m.default || m)
  },
  {
    name: _91url_93IWurBbTXWtMeta?.name ?? "ideas-top-ideas-picks-url___en-gb",
    path: _91url_93IWurBbTXWtMeta?.path ?? "/en-gb/ideas/top-ideas-picks/:url()",
    meta: _91url_93IWurBbTXWtMeta || {},
    alias: _91url_93IWurBbTXWtMeta?.alias || [],
    redirect: _91url_93IWurBbTXWtMeta?.redirect,
    component: () => import("/app/pages/ideas/top-ideas-picks/[url].vue").then(m => m.default || m)
  },
  {
    name: _91url_93IWurBbTXWtMeta?.name ?? "ideas-top-ideas-picks-url___fr",
    path: _91url_93IWurBbTXWtMeta?.path ?? "/fr/ideas/top-ideas-picks/:url()",
    meta: _91url_93IWurBbTXWtMeta || {},
    alias: _91url_93IWurBbTXWtMeta?.alias || [],
    redirect: _91url_93IWurBbTXWtMeta?.redirect,
    component: () => import("/app/pages/ideas/top-ideas-picks/[url].vue").then(m => m.default || m)
  },
  {
    name: index0jvEPa7OuHMeta?.name ?? "image-enhancement___en",
    path: index0jvEPa7OuHMeta?.path ?? "/image-enhancement",
    meta: index0jvEPa7OuHMeta || {},
    alias: index0jvEPa7OuHMeta?.alias || [],
    redirect: index0jvEPa7OuHMeta?.redirect,
    component: () => import("/app/pages/image-enhancement/index.vue").then(m => m.default || m)
  },
  {
    name: index0jvEPa7OuHMeta?.name ?? "image-enhancement___en-gb",
    path: index0jvEPa7OuHMeta?.path ?? "/en-gb/image-enhancement",
    meta: index0jvEPa7OuHMeta || {},
    alias: index0jvEPa7OuHMeta?.alias || [],
    redirect: index0jvEPa7OuHMeta?.redirect,
    component: () => import("/app/pages/image-enhancement/index.vue").then(m => m.default || m)
  },
  {
    name: index0jvEPa7OuHMeta?.name ?? "image-enhancement___fr",
    path: index0jvEPa7OuHMeta?.path ?? "/fr/image-enhancement",
    meta: index0jvEPa7OuHMeta || {},
    alias: index0jvEPa7OuHMeta?.alias || [],
    redirect: index0jvEPa7OuHMeta?.redirect,
    component: () => import("/app/pages/image-enhancement/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___en",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___en-gb",
    path: indexN6pT4Un8hYMeta?.path ?? "/en-gb",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index___fr",
    path: indexN6pT4Un8hYMeta?.path ?? "/fr",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexE0sO6VUll1Meta?.name ?? "interior-design___en",
    path: indexE0sO6VUll1Meta?.path ?? "/interior-design",
    meta: indexE0sO6VUll1Meta || {},
    alias: indexE0sO6VUll1Meta?.alias || [],
    redirect: indexE0sO6VUll1Meta?.redirect,
    component: () => import("/app/pages/interior-design/index.vue").then(m => m.default || m)
  },
  {
    name: indexE0sO6VUll1Meta?.name ?? "interior-design___en-gb",
    path: indexE0sO6VUll1Meta?.path ?? "/en-gb/interior-design",
    meta: indexE0sO6VUll1Meta || {},
    alias: indexE0sO6VUll1Meta?.alias || [],
    redirect: indexE0sO6VUll1Meta?.redirect,
    component: () => import("/app/pages/interior-design/index.vue").then(m => m.default || m)
  },
  {
    name: indexE0sO6VUll1Meta?.name ?? "interior-design___fr",
    path: indexE0sO6VUll1Meta?.path ?? "/fr/interior-design",
    meta: indexE0sO6VUll1Meta || {},
    alias: indexE0sO6VUll1Meta?.alias || [],
    redirect: indexE0sO6VUll1Meta?.redirect,
    component: () => import("/app/pages/interior-design/index.vue").then(m => m.default || m)
  },
  {
    name: indexYIoJIKFD7YMeta?.name ?? "item-removal___en",
    path: indexYIoJIKFD7YMeta?.path ?? "/item-removal",
    meta: indexYIoJIKFD7YMeta || {},
    alias: indexYIoJIKFD7YMeta?.alias || [],
    redirect: indexYIoJIKFD7YMeta?.redirect,
    component: () => import("/app/pages/item-removal/index.vue").then(m => m.default || m)
  },
  {
    name: indexYIoJIKFD7YMeta?.name ?? "item-removal___en-gb",
    path: indexYIoJIKFD7YMeta?.path ?? "/en-gb/item-removal",
    meta: indexYIoJIKFD7YMeta || {},
    alias: indexYIoJIKFD7YMeta?.alias || [],
    redirect: indexYIoJIKFD7YMeta?.redirect,
    component: () => import("/app/pages/item-removal/index.vue").then(m => m.default || m)
  },
  {
    name: indexYIoJIKFD7YMeta?.name ?? "item-removal___fr",
    path: indexYIoJIKFD7YMeta?.path ?? "/fr/item-removal",
    meta: indexYIoJIKFD7YMeta || {},
    alias: indexYIoJIKFD7YMeta?.alias || [],
    redirect: indexYIoJIKFD7YMeta?.redirect,
    component: () => import("/app/pages/item-removal/index.vue").then(m => m.default || m)
  },
  {
    name: indexAyqsaymgxVMeta?.name ?? "miamirealtors___en",
    path: indexAyqsaymgxVMeta?.path ?? "/miamirealtors",
    meta: indexAyqsaymgxVMeta || {},
    alias: indexAyqsaymgxVMeta?.alias || [],
    redirect: indexAyqsaymgxVMeta?.redirect,
    component: () => import("/app/pages/miamirealtors/index.vue").then(m => m.default || m)
  },
  {
    name: indexAyqsaymgxVMeta?.name ?? "miamirealtors___en-gb",
    path: indexAyqsaymgxVMeta?.path ?? "/en-gb/miamirealtors",
    meta: indexAyqsaymgxVMeta || {},
    alias: indexAyqsaymgxVMeta?.alias || [],
    redirect: indexAyqsaymgxVMeta?.redirect,
    component: () => import("/app/pages/miamirealtors/index.vue").then(m => m.default || m)
  },
  {
    name: indexAyqsaymgxVMeta?.name ?? "miamirealtors___fr",
    path: indexAyqsaymgxVMeta?.path ?? "/fr/miamirealtors",
    meta: indexAyqsaymgxVMeta || {},
    alias: indexAyqsaymgxVMeta?.alias || [],
    redirect: indexAyqsaymgxVMeta?.redirect,
    component: () => import("/app/pages/miamirealtors/index.vue").then(m => m.default || m)
  },
  {
    name: indexZ6EUJ1816QMeta?.name ?? "nar-nxt2024___en",
    path: indexZ6EUJ1816QMeta?.path ?? "/nar-nxt2024",
    meta: indexZ6EUJ1816QMeta || {},
    alias: indexZ6EUJ1816QMeta?.alias || [],
    redirect: indexZ6EUJ1816QMeta?.redirect,
    component: () => import("/app/pages/nar-nxt2024/index.vue").then(m => m.default || m)
  },
  {
    name: indexZ6EUJ1816QMeta?.name ?? "nar-nxt2024___en-gb",
    path: indexZ6EUJ1816QMeta?.path ?? "/en-gb/nar-nxt2024",
    meta: indexZ6EUJ1816QMeta || {},
    alias: indexZ6EUJ1816QMeta?.alias || [],
    redirect: indexZ6EUJ1816QMeta?.redirect,
    component: () => import("/app/pages/nar-nxt2024/index.vue").then(m => m.default || m)
  },
  {
    name: indexZ6EUJ1816QMeta?.name ?? "nar-nxt2024___fr",
    path: indexZ6EUJ1816QMeta?.path ?? "/fr/nar-nxt2024",
    meta: indexZ6EUJ1816QMeta || {},
    alias: indexZ6EUJ1816QMeta?.alias || [],
    redirect: indexZ6EUJ1816QMeta?.redirect,
    component: () => import("/app/pages/nar-nxt2024/index.vue").then(m => m.default || m)
  },
  {
    name: indexZu37Q4vm8IMeta?.name ?? "payment___en",
    path: indexZu37Q4vm8IMeta?.path ?? "/payment",
    meta: indexZu37Q4vm8IMeta || {},
    alias: indexZu37Q4vm8IMeta?.alias || [],
    redirect: indexZu37Q4vm8IMeta?.redirect,
    component: () => import("/app/pages/payment/index.vue").then(m => m.default || m)
  },
  {
    name: indexZu37Q4vm8IMeta?.name ?? "payment___en-gb",
    path: indexZu37Q4vm8IMeta?.path ?? "/en-gb/payment",
    meta: indexZu37Q4vm8IMeta || {},
    alias: indexZu37Q4vm8IMeta?.alias || [],
    redirect: indexZu37Q4vm8IMeta?.redirect,
    component: () => import("/app/pages/payment/index.vue").then(m => m.default || m)
  },
  {
    name: indexZu37Q4vm8IMeta?.name ?? "payment___fr",
    path: indexZu37Q4vm8IMeta?.path ?? "/fr/payment",
    meta: indexZu37Q4vm8IMeta || {},
    alias: indexZu37Q4vm8IMeta?.alias || [],
    redirect: indexZu37Q4vm8IMeta?.redirect,
    component: () => import("/app/pages/payment/index.vue").then(m => m.default || m)
  },
  {
    name: indexSaNcJ0PtofMeta?.name ?? "photo-editing___en",
    path: indexSaNcJ0PtofMeta?.path ?? "/photo-editing",
    meta: indexSaNcJ0PtofMeta || {},
    alias: indexSaNcJ0PtofMeta?.alias || [],
    redirect: indexSaNcJ0PtofMeta?.redirect,
    component: () => import("/app/pages/photo-editing/index.vue").then(m => m.default || m)
  },
  {
    name: indexSaNcJ0PtofMeta?.name ?? "photo-editing___en-gb",
    path: indexSaNcJ0PtofMeta?.path ?? "/en-gb/photo-editing",
    meta: indexSaNcJ0PtofMeta || {},
    alias: indexSaNcJ0PtofMeta?.alias || [],
    redirect: indexSaNcJ0PtofMeta?.redirect,
    component: () => import("/app/pages/photo-editing/index.vue").then(m => m.default || m)
  },
  {
    name: indexSaNcJ0PtofMeta?.name ?? "photo-editing___fr",
    path: indexSaNcJ0PtofMeta?.path ?? "/fr/photo-editing",
    meta: indexSaNcJ0PtofMeta || {},
    alias: indexSaNcJ0PtofMeta?.alias || [],
    redirect: indexSaNcJ0PtofMeta?.redirect,
    component: () => import("/app/pages/photo-editing/index.vue").then(m => m.default || m)
  },
  {
    name: indext2mji5fLq5Meta?.name ?? "privacy-policy___en",
    path: indext2mji5fLq5Meta?.path ?? "/privacy-policy",
    meta: indext2mji5fLq5Meta || {},
    alias: indext2mji5fLq5Meta?.alias || [],
    redirect: indext2mji5fLq5Meta?.redirect,
    component: () => import("/app/pages/privacy-policy/index.vue").then(m => m.default || m)
  },
  {
    name: indext2mji5fLq5Meta?.name ?? "privacy-policy___en-gb",
    path: indext2mji5fLq5Meta?.path ?? "/en-gb/privacy-policy",
    meta: indext2mji5fLq5Meta || {},
    alias: indext2mji5fLq5Meta?.alias || [],
    redirect: indext2mji5fLq5Meta?.redirect,
    component: () => import("/app/pages/privacy-policy/index.vue").then(m => m.default || m)
  },
  {
    name: indext2mji5fLq5Meta?.name ?? "privacy-policy___fr",
    path: indext2mji5fLq5Meta?.path ?? "/fr/privacy-policy",
    meta: indext2mji5fLq5Meta || {},
    alias: indext2mji5fLq5Meta?.alias || [],
    redirect: indext2mji5fLq5Meta?.redirect,
    component: () => import("/app/pages/privacy-policy/index.vue").then(m => m.default || m)
  },
  {
    name: indexAP3vXSxH1jMeta?.name ?? "refund-policy___en",
    path: indexAP3vXSxH1jMeta?.path ?? "/refund-policy",
    meta: indexAP3vXSxH1jMeta || {},
    alias: indexAP3vXSxH1jMeta?.alias || [],
    redirect: indexAP3vXSxH1jMeta?.redirect,
    component: () => import("/app/pages/refund-policy/index.vue").then(m => m.default || m)
  },
  {
    name: indexAP3vXSxH1jMeta?.name ?? "refund-policy___en-gb",
    path: indexAP3vXSxH1jMeta?.path ?? "/en-gb/refund-policy",
    meta: indexAP3vXSxH1jMeta || {},
    alias: indexAP3vXSxH1jMeta?.alias || [],
    redirect: indexAP3vXSxH1jMeta?.redirect,
    component: () => import("/app/pages/refund-policy/index.vue").then(m => m.default || m)
  },
  {
    name: indexAP3vXSxH1jMeta?.name ?? "refund-policy___fr",
    path: indexAP3vXSxH1jMeta?.path ?? "/fr/refund-policy",
    meta: indexAP3vXSxH1jMeta || {},
    alias: indexAP3vXSxH1jMeta?.alias || [],
    redirect: indexAP3vXSxH1jMeta?.redirect,
    component: () => import("/app/pages/refund-policy/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_931wqDLF4m1jMeta?.name ?? "share-id___en",
    path: _91id_931wqDLF4m1jMeta?.path ?? "/share/:id()",
    meta: _91id_931wqDLF4m1jMeta || {},
    alias: _91id_931wqDLF4m1jMeta?.alias || [],
    redirect: _91id_931wqDLF4m1jMeta?.redirect,
    component: () => import("/app/pages/share/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_931wqDLF4m1jMeta?.name ?? "share-id___en-gb",
    path: _91id_931wqDLF4m1jMeta?.path ?? "/en-gb/share/:id()",
    meta: _91id_931wqDLF4m1jMeta || {},
    alias: _91id_931wqDLF4m1jMeta?.alias || [],
    redirect: _91id_931wqDLF4m1jMeta?.redirect,
    component: () => import("/app/pages/share/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_931wqDLF4m1jMeta?.name ?? "share-id___fr",
    path: _91id_931wqDLF4m1jMeta?.path ?? "/fr/share/:id()",
    meta: _91id_931wqDLF4m1jMeta || {},
    alias: _91id_931wqDLF4m1jMeta?.alias || [],
    redirect: _91id_931wqDLF4m1jMeta?.redirect,
    component: () => import("/app/pages/share/[id].vue").then(m => m.default || m)
  },
  {
    name: indexeGU814pWZWMeta?.name ?? "terms-and-conditions___en",
    path: indexeGU814pWZWMeta?.path ?? "/terms-and-conditions",
    meta: indexeGU814pWZWMeta || {},
    alias: indexeGU814pWZWMeta?.alias || [],
    redirect: indexeGU814pWZWMeta?.redirect,
    component: () => import("/app/pages/terms-and-conditions/index.vue").then(m => m.default || m)
  },
  {
    name: indexeGU814pWZWMeta?.name ?? "terms-and-conditions___en-gb",
    path: indexeGU814pWZWMeta?.path ?? "/en-gb/terms-and-conditions",
    meta: indexeGU814pWZWMeta || {},
    alias: indexeGU814pWZWMeta?.alias || [],
    redirect: indexeGU814pWZWMeta?.redirect,
    component: () => import("/app/pages/terms-and-conditions/index.vue").then(m => m.default || m)
  },
  {
    name: indexeGU814pWZWMeta?.name ?? "terms-and-conditions___fr",
    path: indexeGU814pWZWMeta?.path ?? "/fr/terms-and-conditions",
    meta: indexeGU814pWZWMeta || {},
    alias: indexeGU814pWZWMeta?.alias || [],
    redirect: indexeGU814pWZWMeta?.redirect,
    component: () => import("/app/pages/terms-and-conditions/index.vue").then(m => m.default || m)
  },
  {
    name: indexzzHG5wCQGdMeta?.name ?? "virtual-staging___en",
    path: indexzzHG5wCQGdMeta?.path ?? "/virtual-staging",
    meta: indexzzHG5wCQGdMeta || {},
    alias: indexzzHG5wCQGdMeta?.alias || [],
    redirect: indexzzHG5wCQGdMeta?.redirect,
    component: () => import("/app/pages/virtual-staging/index.vue").then(m => m.default || m)
  },
  {
    name: indexzzHG5wCQGdMeta?.name ?? "virtual-staging___en-gb",
    path: indexzzHG5wCQGdMeta?.path ?? "/en-gb/virtual-staging",
    meta: indexzzHG5wCQGdMeta || {},
    alias: indexzzHG5wCQGdMeta?.alias || [],
    redirect: indexzzHG5wCQGdMeta?.redirect,
    component: () => import("/app/pages/virtual-staging/index.vue").then(m => m.default || m)
  },
  {
    name: indexzzHG5wCQGdMeta?.name ?? "virtual-staging___fr",
    path: indexzzHG5wCQGdMeta?.path ?? "/fr/virtual-staging",
    meta: indexzzHG5wCQGdMeta || {},
    alias: indexzzHG5wCQGdMeta?.alias || [],
    redirect: indexzzHG5wCQGdMeta?.redirect,
    component: () => import("/app/pages/virtual-staging/index.vue").then(m => m.default || m)
  },
  {
    name: indexppcWwnaIjyMeta?.name ?? "pricing___en",
    path: indexppcWwnaIjyMeta?.path ?? "/pricing",
    meta: indexppcWwnaIjyMeta || {},
    alias: indexppcWwnaIjyMeta?.alias || [],
    redirect: indexppcWwnaIjyMeta?.redirect,
    component: () => import("/app/modules/pricing/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexppcWwnaIjyMeta?.name ?? "pricing___en-gb",
    path: indexppcWwnaIjyMeta?.path ?? "/en-gb/pricing",
    meta: indexppcWwnaIjyMeta || {},
    alias: indexppcWwnaIjyMeta?.alias || [],
    redirect: indexppcWwnaIjyMeta?.redirect,
    component: () => import("/app/modules/pricing/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexppcWwnaIjyMeta?.name ?? "pricing___fr",
    path: indexppcWwnaIjyMeta?.path ?? "/fr/pricing",
    meta: indexppcWwnaIjyMeta || {},
    alias: indexppcWwnaIjyMeta?.alias || [],
    redirect: indexppcWwnaIjyMeta?.redirect,
    component: () => import("/app/modules/pricing/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexs61vCSxqLMMeta?.name ?? "billing___en",
    path: indexs61vCSxqLMMeta?.path ?? "/billing",
    meta: indexs61vCSxqLMMeta || {},
    alias: indexs61vCSxqLMMeta?.alias || [],
    redirect: indexs61vCSxqLMMeta?.redirect,
    component: () => import("/app/modules/billing/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexs61vCSxqLMMeta?.name ?? "billing___en-gb",
    path: indexs61vCSxqLMMeta?.path ?? "/en-gb/billing",
    meta: indexs61vCSxqLMMeta || {},
    alias: indexs61vCSxqLMMeta?.alias || [],
    redirect: indexs61vCSxqLMMeta?.redirect,
    component: () => import("/app/modules/billing/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexs61vCSxqLMMeta?.name ?? "billing___fr",
    path: indexs61vCSxqLMMeta?.path ?? "/fr/billing",
    meta: indexs61vCSxqLMMeta || {},
    alias: indexs61vCSxqLMMeta?.alias || [],
    redirect: indexs61vCSxqLMMeta?.redirect,
    component: () => import("/app/modules/billing/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTzFcCB2TOWMeta?.name ?? "api-access___en",
    path: indexTzFcCB2TOWMeta?.path ?? "/api-access",
    meta: indexTzFcCB2TOWMeta || {},
    alias: indexTzFcCB2TOWMeta?.alias || [],
    redirect: indexTzFcCB2TOWMeta?.redirect,
    component: () => import("/app/modules/api-access/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTzFcCB2TOWMeta?.name ?? "api-access___en-gb",
    path: indexTzFcCB2TOWMeta?.path ?? "/en-gb/api-access",
    meta: indexTzFcCB2TOWMeta || {},
    alias: indexTzFcCB2TOWMeta?.alias || [],
    redirect: indexTzFcCB2TOWMeta?.redirect,
    component: () => import("/app/modules/api-access/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTzFcCB2TOWMeta?.name ?? "api-access___fr",
    path: indexTzFcCB2TOWMeta?.path ?? "/fr/api-access",
    meta: indexTzFcCB2TOWMeta || {},
    alias: indexTzFcCB2TOWMeta?.alias || [],
    redirect: indexTzFcCB2TOWMeta?.redirect,
    component: () => import("/app/modules/api-access/pages/index.vue").then(m => m.default || m)
  },
  {
    name: logs2gDoHoeyr8Meta?.name ?? "api-access-logs___en",
    path: logs2gDoHoeyr8Meta?.path ?? "/api-access/logs",
    meta: logs2gDoHoeyr8Meta || {},
    alias: logs2gDoHoeyr8Meta?.alias || [],
    redirect: logs2gDoHoeyr8Meta?.redirect,
    component: () => import("/app/modules/api-access/pages/logs.vue").then(m => m.default || m)
  },
  {
    name: logs2gDoHoeyr8Meta?.name ?? "api-access-logs___en-gb",
    path: logs2gDoHoeyr8Meta?.path ?? "/en-gb/api-access/logs",
    meta: logs2gDoHoeyr8Meta || {},
    alias: logs2gDoHoeyr8Meta?.alias || [],
    redirect: logs2gDoHoeyr8Meta?.redirect,
    component: () => import("/app/modules/api-access/pages/logs.vue").then(m => m.default || m)
  },
  {
    name: logs2gDoHoeyr8Meta?.name ?? "api-access-logs___fr",
    path: logs2gDoHoeyr8Meta?.path ?? "/fr/api-access/logs",
    meta: logs2gDoHoeyr8Meta || {},
    alias: logs2gDoHoeyr8Meta?.alias || [],
    redirect: logs2gDoHoeyr8Meta?.redirect,
    component: () => import("/app/modules/api-access/pages/logs.vue").then(m => m.default || m)
  },
  {
    name: index7R0Nkm3DOvMeta?.name ?? "bulk-group___en",
    path: index7R0Nkm3DOvMeta?.path ?? "/bulk/:orderGroupId",
    meta: index7R0Nkm3DOvMeta || {},
    alias: index7R0Nkm3DOvMeta?.alias || [],
    redirect: index7R0Nkm3DOvMeta?.redirect,
    component: () => createClientPage(() => import("/app/modules/bulk/pages/index.vue").then(m => m.default || m)),
    children: [
  {
    name: singleLIXEwMzMWKMeta?.name ?? "bulk-single___en",
    path: singleLIXEwMzMWKMeta?.path ?? ":orderId",
    meta: singleLIXEwMzMWKMeta || {},
    alias: singleLIXEwMzMWKMeta?.alias || [],
    redirect: singleLIXEwMzMWKMeta?.redirect,
    component: () => createClientPage(() => import("/app/modules/bulk/pages/single.vue").then(m => m.default || m))
  },
  {
    name: multiCOGediCAuRMeta?.name ?? "bulk-multi___en",
    path: multiCOGediCAuRMeta?.path ?? "multi",
    meta: multiCOGediCAuRMeta || {},
    alias: multiCOGediCAuRMeta?.alias || [],
    redirect: multiCOGediCAuRMeta?.redirect,
    component: () => createClientPage(() => import("/app/modules/bulk/pages/multi.vue").then(m => m.default || m))
  }
]
  },
  {
    name: index7R0Nkm3DOvMeta?.name ?? "bulk-group___en-gb",
    path: index7R0Nkm3DOvMeta?.path ?? "/en-gb/bulk/:orderGroupId",
    meta: index7R0Nkm3DOvMeta || {},
    alias: index7R0Nkm3DOvMeta?.alias || [],
    redirect: index7R0Nkm3DOvMeta?.redirect,
    component: () => createClientPage(() => import("/app/modules/bulk/pages/index.vue").then(m => m.default || m)),
    children: [
  {
    name: singleLIXEwMzMWKMeta?.name ?? "bulk-single___en-gb",
    path: singleLIXEwMzMWKMeta?.path ?? ":orderId",
    meta: singleLIXEwMzMWKMeta || {},
    alias: singleLIXEwMzMWKMeta?.alias || [],
    redirect: singleLIXEwMzMWKMeta?.redirect,
    component: () => createClientPage(() => import("/app/modules/bulk/pages/single.vue").then(m => m.default || m))
  },
  {
    name: multiCOGediCAuRMeta?.name ?? "bulk-multi___en-gb",
    path: multiCOGediCAuRMeta?.path ?? "multi",
    meta: multiCOGediCAuRMeta || {},
    alias: multiCOGediCAuRMeta?.alias || [],
    redirect: multiCOGediCAuRMeta?.redirect,
    component: () => createClientPage(() => import("/app/modules/bulk/pages/multi.vue").then(m => m.default || m))
  }
]
  },
  {
    name: index7R0Nkm3DOvMeta?.name ?? "bulk-group___fr",
    path: index7R0Nkm3DOvMeta?.path ?? "/fr/bulk/:orderGroupId",
    meta: index7R0Nkm3DOvMeta || {},
    alias: index7R0Nkm3DOvMeta?.alias || [],
    redirect: index7R0Nkm3DOvMeta?.redirect,
    component: () => createClientPage(() => import("/app/modules/bulk/pages/index.vue").then(m => m.default || m)),
    children: [
  {
    name: singleLIXEwMzMWKMeta?.name ?? "bulk-single___fr",
    path: singleLIXEwMzMWKMeta?.path ?? ":orderId",
    meta: singleLIXEwMzMWKMeta || {},
    alias: singleLIXEwMzMWKMeta?.alias || [],
    redirect: singleLIXEwMzMWKMeta?.redirect,
    component: () => createClientPage(() => import("/app/modules/bulk/pages/single.vue").then(m => m.default || m))
  },
  {
    name: multiCOGediCAuRMeta?.name ?? "bulk-multi___fr",
    path: multiCOGediCAuRMeta?.path ?? "multi",
    meta: multiCOGediCAuRMeta || {},
    alias: multiCOGediCAuRMeta?.alias || [],
    redirect: multiCOGediCAuRMeta?.redirect,
    component: () => createClientPage(() => import("/app/modules/bulk/pages/multi.vue").then(m => m.default || m))
  }
]
  },
  {
    name: indexq0RnSEaoHEMeta?.name ?? "generated-photos___en",
    path: indexq0RnSEaoHEMeta?.path ?? "/generated-photos",
    meta: indexq0RnSEaoHEMeta || {},
    alias: indexq0RnSEaoHEMeta?.alias || [],
    redirect: indexq0RnSEaoHEMeta?.redirect,
    component: () => import("/app/modules/generated-photos/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexq0RnSEaoHEMeta?.name ?? "generated-photos___en-gb",
    path: indexq0RnSEaoHEMeta?.path ?? "/en-gb/generated-photos",
    meta: indexq0RnSEaoHEMeta || {},
    alias: indexq0RnSEaoHEMeta?.alias || [],
    redirect: indexq0RnSEaoHEMeta?.redirect,
    component: () => import("/app/modules/generated-photos/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexq0RnSEaoHEMeta?.name ?? "generated-photos___fr",
    path: indexq0RnSEaoHEMeta?.path ?? "/fr/generated-photos",
    meta: indexq0RnSEaoHEMeta || {},
    alias: indexq0RnSEaoHEMeta?.alias || [],
    redirect: indexq0RnSEaoHEMeta?.redirect,
    component: () => import("/app/modules/generated-photos/pages/index.vue").then(m => m.default || m)
  },
  {
    name: singleq818QydQhsMeta?.name ?? "single-generated-photo___en",
    path: singleq818QydQhsMeta?.path ?? "/generated-photos/:orderId",
    meta: singleq818QydQhsMeta || {},
    alias: singleq818QydQhsMeta?.alias || [],
    redirect: singleq818QydQhsMeta?.redirect,
    component: () => import("/app/modules/generated-photos/pages/single.vue").then(m => m.default || m)
  },
  {
    name: singleq818QydQhsMeta?.name ?? "single-generated-photo___en-gb",
    path: singleq818QydQhsMeta?.path ?? "/en-gb/generated-photos/:orderId",
    meta: singleq818QydQhsMeta || {},
    alias: singleq818QydQhsMeta?.alias || [],
    redirect: singleq818QydQhsMeta?.redirect,
    component: () => import("/app/modules/generated-photos/pages/single.vue").then(m => m.default || m)
  },
  {
    name: singleq818QydQhsMeta?.name ?? "single-generated-photo___fr",
    path: singleq818QydQhsMeta?.path ?? "/fr/generated-photos/:orderId",
    meta: singleq818QydQhsMeta || {},
    alias: singleq818QydQhsMeta?.alias || [],
    redirect: singleq818QydQhsMeta?.redirect,
    component: () => import("/app/modules/generated-photos/pages/single.vue").then(m => m.default || m)
  },
  {
    name: singleGroupMKq5TLXY9KMeta?.name ?? "vsManual-single-generated-photo___en",
    path: singleGroupMKq5TLXY9KMeta?.path ?? "/generated-photos/vs-manual/:orderGroupId",
    meta: singleGroupMKq5TLXY9KMeta || {},
    alias: singleGroupMKq5TLXY9KMeta?.alias || [],
    redirect: singleGroupMKq5TLXY9KMeta?.redirect,
    component: () => import("/app/modules/generated-photos/pages/singleGroup.vue").then(m => m.default || m)
  },
  {
    name: singleGroupMKq5TLXY9KMeta?.name ?? "vsManual-single-generated-photo___en-gb",
    path: singleGroupMKq5TLXY9KMeta?.path ?? "/en-gb/generated-photos/vs-manual/:orderGroupId",
    meta: singleGroupMKq5TLXY9KMeta || {},
    alias: singleGroupMKq5TLXY9KMeta?.alias || [],
    redirect: singleGroupMKq5TLXY9KMeta?.redirect,
    component: () => import("/app/modules/generated-photos/pages/singleGroup.vue").then(m => m.default || m)
  },
  {
    name: singleGroupMKq5TLXY9KMeta?.name ?? "vsManual-single-generated-photo___fr",
    path: singleGroupMKq5TLXY9KMeta?.path ?? "/fr/generated-photos/vs-manual/:orderGroupId",
    meta: singleGroupMKq5TLXY9KMeta || {},
    alias: singleGroupMKq5TLXY9KMeta?.alias || [],
    redirect: singleGroupMKq5TLXY9KMeta?.redirect,
    component: () => import("/app/modules/generated-photos/pages/singleGroup.vue").then(m => m.default || m)
  },
  {
    name: singleL8F2sP93JjMeta?.name ?? "bookmark-single-generated-photo___en",
    path: singleL8F2sP93JjMeta?.path ?? "/generated-photos/bookmark/:imageId",
    meta: singleL8F2sP93JjMeta || {},
    alias: singleL8F2sP93JjMeta?.alias || [],
    redirect: singleL8F2sP93JjMeta?.redirect,
    component: () => import("/app/modules/generated-photos/pages/bookmark/single.vue").then(m => m.default || m)
  },
  {
    name: singleL8F2sP93JjMeta?.name ?? "bookmark-single-generated-photo___en-gb",
    path: singleL8F2sP93JjMeta?.path ?? "/en-gb/generated-photos/bookmark/:imageId",
    meta: singleL8F2sP93JjMeta || {},
    alias: singleL8F2sP93JjMeta?.alias || [],
    redirect: singleL8F2sP93JjMeta?.redirect,
    component: () => import("/app/modules/generated-photos/pages/bookmark/single.vue").then(m => m.default || m)
  },
  {
    name: singleL8F2sP93JjMeta?.name ?? "bookmark-single-generated-photo___fr",
    path: singleL8F2sP93JjMeta?.path ?? "/fr/generated-photos/bookmark/:imageId",
    meta: singleL8F2sP93JjMeta || {},
    alias: singleL8F2sP93JjMeta?.alias || [],
    redirect: singleL8F2sP93JjMeta?.redirect,
    component: () => import("/app/modules/generated-photos/pages/bookmark/single.vue").then(m => m.default || m)
  },
  {
    name: IRDrawFjW0lcuOW0Meta?.name ?? "ir-mask-draw___en",
    path: IRDrawFjW0lcuOW0Meta?.path ?? "/dashboard/generate/ir-mask/:orderId",
    meta: { ...(IRDrawFjW0lcuOW0Meta || {}), ...{"layout":"nothing"} },
    alias: IRDrawFjW0lcuOW0Meta?.alias || [],
    redirect: IRDrawFjW0lcuOW0Meta?.redirect,
    component: () => import("/app/modules/ir-mask/pages/IRDraw.vue").then(m => m.default || m)
  },
  {
    name: IRDrawFjW0lcuOW0Meta?.name ?? "ir-mask-draw___en-gb",
    path: IRDrawFjW0lcuOW0Meta?.path ?? "/en-gb/dashboard/generate/ir-mask/:orderId",
    meta: { ...(IRDrawFjW0lcuOW0Meta || {}), ...{"layout":"nothing"} },
    alias: IRDrawFjW0lcuOW0Meta?.alias || [],
    redirect: IRDrawFjW0lcuOW0Meta?.redirect,
    component: () => import("/app/modules/ir-mask/pages/IRDraw.vue").then(m => m.default || m)
  },
  {
    name: IRDrawFjW0lcuOW0Meta?.name ?? "ir-mask-draw___fr",
    path: IRDrawFjW0lcuOW0Meta?.path ?? "/fr/dashboard/generate/ir-mask/:orderId",
    meta: { ...(IRDrawFjW0lcuOW0Meta || {}), ...{"layout":"nothing"} },
    alias: IRDrawFjW0lcuOW0Meta?.alias || [],
    redirect: IRDrawFjW0lcuOW0Meta?.redirect,
    component: () => import("/app/modules/ir-mask/pages/IRDraw.vue").then(m => m.default || m)
  },
  {
    name: DayToDuskaw1bmjnIdLMeta?.name ?? "",
    path: DayToDuskaw1bmjnIdLMeta?.path ?? "/dashboard/service-day-to-dusk/post-process/:imageId",
    meta: { ...(DayToDuskaw1bmjnIdLMeta || {}), ...{"layout":"nothing"} },
    alias: DayToDuskaw1bmjnIdLMeta?.alias || [],
    redirect: DayToDuskaw1bmjnIdLMeta?.redirect,
    component: () => import("/app/modules/day-to-dusk/pages/DayToDusk.vue").then(m => m.default || m)
  },
  {
    name: DayToDuskaw1bmjnIdLMeta?.name ?? "",
    path: DayToDuskaw1bmjnIdLMeta?.path ?? "/en-gb/dashboard/service-day-to-dusk/post-process/:imageId",
    meta: { ...(DayToDuskaw1bmjnIdLMeta || {}), ...{"layout":"nothing"} },
    alias: DayToDuskaw1bmjnIdLMeta?.alias || [],
    redirect: DayToDuskaw1bmjnIdLMeta?.redirect,
    component: () => import("/app/modules/day-to-dusk/pages/DayToDusk.vue").then(m => m.default || m)
  },
  {
    name: DayToDuskaw1bmjnIdLMeta?.name ?? "",
    path: DayToDuskaw1bmjnIdLMeta?.path ?? "/fr/dashboard/service-day-to-dusk/post-process/:imageId",
    meta: { ...(DayToDuskaw1bmjnIdLMeta || {}), ...{"layout":"nothing"} },
    alias: DayToDuskaw1bmjnIdLMeta?.alias || [],
    redirect: DayToDuskaw1bmjnIdLMeta?.redirect,
    component: () => import("/app/modules/day-to-dusk/pages/DayToDusk.vue").then(m => m.default || m)
  },
  {
    name: membersW5qEhMW9jbMeta?.name ?? "sub-account-members___en",
    path: membersW5qEhMW9jbMeta?.path ?? "/sub-account/members",
    meta: membersW5qEhMW9jbMeta || {},
    alias: membersW5qEhMW9jbMeta?.alias || [],
    redirect: membersW5qEhMW9jbMeta?.redirect,
    component: () => import("/app/modules/sub-account/pages/members.vue").then(m => m.default || m)
  },
  {
    name: membersW5qEhMW9jbMeta?.name ?? "sub-account-members___en-gb",
    path: membersW5qEhMW9jbMeta?.path ?? "/en-gb/sub-account/members",
    meta: membersW5qEhMW9jbMeta || {},
    alias: membersW5qEhMW9jbMeta?.alias || [],
    redirect: membersW5qEhMW9jbMeta?.redirect,
    component: () => import("/app/modules/sub-account/pages/members.vue").then(m => m.default || m)
  },
  {
    name: membersW5qEhMW9jbMeta?.name ?? "sub-account-members___fr",
    path: membersW5qEhMW9jbMeta?.path ?? "/fr/sub-account/members",
    meta: membersW5qEhMW9jbMeta || {},
    alias: membersW5qEhMW9jbMeta?.alias || [],
    redirect: membersW5qEhMW9jbMeta?.redirect,
    component: () => import("/app/modules/sub-account/pages/members.vue").then(m => m.default || m)
  },
  {
    name: verifyU9K92YbSeyMeta?.name ?? "sub-account-verify___en",
    path: verifyU9K92YbSeyMeta?.path ?? "/sub-account/verify",
    meta: verifyU9K92YbSeyMeta || {},
    alias: verifyU9K92YbSeyMeta?.alias || [],
    redirect: verifyU9K92YbSeyMeta?.redirect,
    component: () => import("/app/modules/sub-account/pages/verify.vue").then(m => m.default || m)
  },
  {
    name: verifyU9K92YbSeyMeta?.name ?? "sub-account-verify___en-gb",
    path: verifyU9K92YbSeyMeta?.path ?? "/en-gb/sub-account/verify",
    meta: verifyU9K92YbSeyMeta || {},
    alias: verifyU9K92YbSeyMeta?.alias || [],
    redirect: verifyU9K92YbSeyMeta?.redirect,
    component: () => import("/app/modules/sub-account/pages/verify.vue").then(m => m.default || m)
  },
  {
    name: verifyU9K92YbSeyMeta?.name ?? "sub-account-verify___fr",
    path: verifyU9K92YbSeyMeta?.path ?? "/fr/sub-account/verify",
    meta: verifyU9K92YbSeyMeta || {},
    alias: verifyU9K92YbSeyMeta?.alias || [],
    redirect: verifyU9K92YbSeyMeta?.redirect,
    component: () => import("/app/modules/sub-account/pages/verify.vue").then(m => m.default || m)
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/dashboard/upload-photo",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/fr/dashboard/upload-photo",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/dashboard/generate",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/en-gb/dashboard/upload-photo",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/dashboard/virtual-staging",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/dashboard/interior-design",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/dashboard/image-enhancement",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/dashboard/day-to-dusk",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/dashboard/item-removal",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  },
  {
    name: component_45stubTOq3NWgWLHMeta?.name ?? undefined,
    path: component_45stubTOq3NWgWLHMeta?.path ?? "/sitemap.xml",
    meta: component_45stubTOq3NWgWLHMeta || {},
    alias: component_45stubTOq3NWgWLHMeta?.alias || [],
    redirect: component_45stubTOq3NWgWLHMeta?.redirect,
    component: component_45stubTOq3NWgWLH
  }
]